import { render, staticRenderFns } from "./BillKassa.vue?vue&type=template&id=46478659&scoped=true"
import script from "./BillKassa.vue?vue&type=script&lang=js"
export * from "./BillKassa.vue?vue&type=script&lang=js"
import style0 from "./BillKassa.vue?vue&type=style&index=0&id=46478659&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46478659",
  null
  
)

export default component.exports